export const contactsData = {
    email: 'aidanarmstrong4@gmail.com',
    phone: '+44 7510028620',
    address: 'Ireland',

    sheetAPI: ''
}